import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ilens from "../../../src/shared/images/ilens.jpg";
import './Login.scss';
import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { GoogleLogin } from '@react-oauth/google';
import { useState } from "react";
import { authorizationService } from "../../shared/api_services/authorizationService";
import CryptoJS from "crypto-js";
import { SecretKeys } from "../../shared/Constants/SecretKey";
import { useSharedState } from "../../components/services/WindowSizeService";
// import microsoft from "../../../src/shared/images/ilens-white.png";
import microsoft from "../../shared/images/microsoft-logo-png-2396.png";
import MicrosoftLogin from "react-microsoft-login";
import { alertService } from "../../shared/UI Components/Services/alertService";
import { encrypt, endSession, getURLDataMethod } from "../../shared/Utils/Utils";

const Login = () => {
    const windowSize$ = useSharedState();
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);
    const [inputs, setInputs] = useState<any>({});
    const [disabledLogin, setDisabledLogin] = useState<any>(false);
    let secretKey: any = SecretKeys.cryptoSecretKey;

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }

    // Login through User Credentials
    const userNormalLogin = async (userName: any, userPassword: any) => {
        let returnFlag = false;
        let payload: any = {};
        payload["user_name"] = userName;
        payload["password"] = userPassword;
        payload["login_type"] = "general_login";
        try {
            return await authorizationService.login("login", payload).then((res: any) => {
                if (res.status === 200) {
                    if (res.body) {
                        if (res?.body?.status === "success") {
                            let response = JSON.parse(JSON.stringify(res.body.data))
                            localStorage.setItem("ilensDatalogger", CryptoJS.AES.encrypt(JSON.stringify(res.body.data), secretKey).toString());
                            let tempSession: any = {
                                "currentSession": true,
                                "hasURLDetails": getURLDataMethod() ? true : false,
                            }
                            localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
                            // setURLfromURL()
                            returnFlag = true;
                            window.location.reload();
                            return returnFlag;
                        }
                        else {
                            alertService.serviceErrorMessage(res?.body?.message)
                        }
                    }
                    console.log(res);
                }
                else {
                    console.log("error");
                }
            })
        } catch (err: any) {
            console.log(err);
        }
    }


    const validateUser = () => {
        if (inputs?.username?.length > 4 && inputs?.username && inputs?.password) {
            let encryptedPass: any = "";
            if (inputs?.password) {
                encryptedPass = CryptoJS.AES.encrypt(inputs?.password, "kliLensKLiLensKL").toString();
            }
            let encPass: any = encrypt(inputs?.password);
            userNormalLogin(inputs?.username, encPass)
        }
    }

    const submitForm = () => {
        setSubmitFlag(true);
        validateUser();
    }

    const setURLfromURL = () => {
        let URL_Data: any = window.location.href;
        if (URL_Data.split('deviceConfig/')?.[1]) {
            localStorage.setItem("url", URL_Data.split('deviceConfig/')?.[1]);
        }
    }

    // Login through gmail
    const googleLogin = async (credential: any) => {
        let returnFlag = false;
        let payload: any = {};
        payload["id_token"] = credential;
        payload["login_type"] = "google";
        try {
            return await authorizationService.login("login", payload).then((res: any) => {
                if (res.status === 200) {
                    if (res.body) {
                        if (res?.body?.status === "failed") {
                            alertService.serviceErrorMessage(res?.body?.message);
                        }
                        setDisabledLogin(false);
                        let response = JSON.parse(JSON.stringify(res.body.data))
                        localStorage.setItem("ilensDatalogger", CryptoJS.AES.encrypt(JSON.stringify(res.body.data), secretKey).toString());
                        let tempSession: any = {
                            "currentSession": true,
                            "hasURLDetails": getURLDataMethod() ? true : false,
                        }
                        localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
                        // setURLfromURL()
                        returnFlag = true;
                        return returnFlag;
                    }
                    else {
                        console.log(res);
                    }
                }
                else {
                    console.log("error");
                }
            })
        } catch (err: any) {
            console.log(err);
        }
    }

    // Response from successful Gmail login 
    const responseMessage = async (response: any) => {
        setDisabledLogin(true)
        if (await googleLogin(response.credential)) {
            window.location.reload();
        }
    };

    const errorMessage = (error: void) => {
        console.log(error);
    };

    const authHandler = (err: any, data: any) => {
        console.log(err, data);
    };

    // Custom HTML for Microsoft Login
    const customDiv = () => {
        return (
            <div className="google-login mt-4 pointer">
                <img src={microsoft} className="logo" alt="Microsoft" />
            </div>
        )
    }

    return (
        <div className="login">
            <div className="login-row">
                <div className="row m-0">
                    {windowSize$ === "sm" || windowSize$ === "xs" ?
                        <>
                            <div className="login-container mt-5 col-md-12">
                                <div className="">
                                    <div>
                                        <div className="main-head">
                                            DATA LOGGER
                                        </div>
                                        <div className="sign-in my-4">
                                            Sign In
                                        </div>
                                    </div>
                                    <div className="my-3">
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faUser} className="mr-2" />
                                            <label className="label-style" >User ID</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="text"
                                                name="username"
                                                value={inputs?.username ? inputs?.username : ""}
                                                placeholder="User ID"
                                                className="form-control form-control-bordered my-2"
                                                autoComplete="nope"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.username &&
                                                <div className="text-danger">Please Enter Username</div>
                                            }
                                        </div>
                                        <div className="my-4">
                                            <FontAwesomeIcon icon={faLock} className="mr-2" />
                                            <label className="label-style">Password</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="password"
                                                name="password"
                                                value={inputs?.password ? inputs?.password : ""}
                                                placeholder="Password"
                                                className="form-control form-control-bordered my-2"
                                                autoComplete="new-password"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.password &&
                                                <div className="text-danger">Please Enter Password</div>
                                            }

                                        </div>
                                        <div className=" pt-0 my-4 py-3" >
                                            <button attr-test="modal-submit" type="button" className="btn btn-login  w-100" onClick={submitForm}>
                                                <span className="login-label">
                                                    Log In
                                                </span>
                                            </button>
                                        </div>
                                        <div className="separator">
                                            <span className="separator-or">
                                                or
                                            </span>
                                        </div>
                                        <div className="google-login">
                                            <GoogleLogin
                                                onSuccess={responseMessage}
                                                onError={errorMessage}
                                                useOneTap
                                            />
                                        </div>
                                        {/* MicroSoft */}
                                        {/* <div className="px-5">
                                            <div className="microsoft-login pointer mt-3">
                                                <MicrosoftLogin clientId="6a8ff37e-414f-47a3-897b-e0a06bae01af" authCallback={authHandler} children={
                                                    <div className="google-login m-1 pointer">
                                                        <img src={microsoft} className="logo" alt="Microsoft" />
                                                    </div>}
                                                />
                                            </div>
                                        </div> */}
                                        {/* MicroSoft */}
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="col-md-8 col-lg-8 pl-0">
                                <img src={ilens} className="ilens-login" alt="Data Logger" />
                            </div>
                            <div className="login-container col-md-4">
                                <div>
                                    <div>
                                        <div className="main-head">
                                            DATA LOGGER
                                        </div>
                                        <div className="sign-in my-2">
                                            Sign In
                                        </div>
                                    </div>
                                    <div className="my-2">
                                        <div className="my-2">
                                            <FontAwesomeIcon icon={faUser} className="mr-2" />
                                            <label className="label-style" >User ID</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="text"
                                                name="username"
                                                value={inputs?.username ? inputs?.username : ""}
                                                placeholder="User ID"
                                                className="form-control form-control-bordered mt-2 mb-1"
                                                autoComplete="nope"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.username &&
                                                <div className="text-danger">Please Enter Username</div>
                                            }
                                        </div>
                                        <div className="my-2">
                                            <FontAwesomeIcon icon={faLock} className="mr-2" />
                                            <label className="label-style">Password</label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="password"
                                                name="password"
                                                value={inputs?.password ? inputs?.password : ""}
                                                placeholder="Password"
                                                className="form-control form-control-bordered mt-2 mb-1"
                                                autoComplete="new-password"
                                                onChange={handleChange}
                                            />
                                            {submitFlag && !inputs?.password &&
                                                <div className="text-danger">Please Enter Username</div>
                                            }

                                        </div>
                                        {/* <div>
                                            <FontAwesomeIcon icon={faAddressCard} className="mr-2" />
                                            <label className="label-style">Temporary URL</label>
                                            <input
                                                type="text"
                                                name="url"
                                                value={tempURL ? tempURL : ""}
                                                placeholder="Temporary URL"
                                                className="form-control form-control-bordered my-2"
                                                autoComplete="nope"
                                                onChange={handleChangeURL}
                                            />
                                        </div> */}
                                        <div className=" pt-0 my-4 py-1" >
                                            <button attr-test="modal-submit" type="button" disabled={disabledLogin} className="btn btn-login  w-100" onClick={submitForm}>
                                                <span className="login-label">
                                                    {disabledLogin ?
                                                        <>Loading..</>
                                                        :
                                                        <>Log In</>
                                                    }
                                                </span>
                                            </button>
                                        </div>
                                        <div className="separator">
                                            <span className="separator-or">
                                                or
                                            </span>
                                        </div>
                                        <div className="google-login">
                                            <GoogleLogin
                                                onSuccess={responseMessage}
                                                onError={errorMessage}
                                                useOneTap
                                            />
                                        </div>
                                        {/* <div className="separator">
                                            <span className="separator-or">
                                                or
                                            </span>
                                        </div> */}
                                        {/* <div className="google-login mt-4 pointer">
                                            <img src={microsoft} className="logo" alt="Microsoft" />
                                        </div> */}

                                        {/* MicroSoft */}
                                        {/* <div className="px-3">
                                            <div className="microsoft-login pointer mt-3">
                                                <MicrosoftLogin clientId="6a8ff37e-414f-47a3-897b-e0a06bae01af" authCallback={authHandler} children={
                                                    <div className="google-login m-1 pointer">
                                                        <img src={microsoft} className="logo" alt="Microsoft" />
                                                    </div>}
                                                />
                                            </div>
                                        </div> */}
                                        {/* MicroSoft */}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
export default Login;